import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  useTheme,
  Stack,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import _get from 'lodash/get';
import TableRowSort from './components/TableRowSort.component';
import TableToolbar from '../table/components/TableToolbar.component';

const SimpleTable = ({
  data,
  minWidth = 650,
  module,
  maxHeight = 450,
  numSelected,
  onSort = () => {},
  onSelectAll = () => {},
  order,
  orderBy,
  body,
  isChecked,
  height,
  minHeight,
  stickyHeader = true,
  ...props
}) => {
  const theme = useTheme();
  const {
    list: {
      conf: { columns, render },
    },
  } = module;

  return (
    <Stack>
      <TableToolbar numSelected={numSelected} />

      <TableContainer
        component={Paper}
        sx={{
          maxHeight: maxHeight,
          height: height || 'auto',
          minHeight: minHeight,
        }}
      >
        <Table stickyHeader={stickyHeader} sx={{ minWidth: minWidth }}>
          <TableHead>
            <TableRowSort
              columns={columns}
              rows={data}
              onSort={onSort}
              order={order}
              orderBy={orderBy}
              onSelectAll={onSelectAll}
              isChecked={isChecked}
              backgroundColor={props?.backgroundColor}
              colorText={props?.colorText}
              numSelected={numSelected}
            />
          </TableHead>

          {!body ? (
            <TableBody>
              {data?.map((item) => {
                return (
                  <TableRow
                    key={item?.id || uuidv4()}
                    sx={{
                      '&:nth-of-type(even)': {
                        backgroundColor: theme.palette.secondary.medium_20,
                      },
                    }}
                  >
                    {columns?.map(({ key, id, width }) => (
                      <TableCell key={uuidv4()} width={width || 'auto'}>
                        {render?.formatValue(key, _get(item, id), () => {})}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            body
          )}
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default SimpleTable;
